export type AppType = "admin" | "investor";

let currentAppType: AppType | null = null;

/**
 * Set the app type once at app startup.
 * Used to send X-App-Type header for scoped refresh cookies.
 */
export const setAppType = (appType: AppType): void => {
  currentAppType = appType;
};

/**
 * Get the current app type. Returns null if not set.
 */
export const getAppType = (): AppType | null => {
  return currentAppType;
};
